import React, { useEffect } from 'react';
import styled from 'styled-components';
import db from '../../db';
import { onSnapshot, collection, query } from "firebase/firestore";
import Service1 from '../../Image/service1.png';
import Service2 from '../../Image/service2.png';
import Service3 from '../../Image/service3.png';

// const servicesData = [
//     { id: 1, title: 'Immediate Care', image: Service1 },
//     { id: 2, title: 'Dental Care', image: Service2 },
//     { id: 3, title: 'Diagnostic Center', image: Service3 },
// ];

const Services = () => {
  
    const [servicesData, setServicesData] = React.useState([])


    useEffect(() => {
        const q = query(collection(db, "OurServices"))
        const unsub = onSnapshot(q, (querySnapshot) => {
            setServicesData(querySnapshot.docs.map(d => d.data()))
        });
        return () => unsub();
    }, []);
    
    return (
        <MainServices>
            <HeadingService>Our Services</HeadingService>
            <ServiceContainer>
                {servicesData.map((service) => (
                    <ServiceCard key={service.serviceid}>
                        <ServiceImageContainer>
                            <ServiceImage src={Service1} alt={service.servicename} />
                            <ServiceOverlay>
                                <ServiceHeading>{service.servicename}</ServiceHeading>
                            </ServiceOverlay>
                        </ServiceImageContainer>
                    </ServiceCard>
                ))}
            </ServiceContainer>
        </MainServices>
    );
};

export default Services;

const MainServices = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
`;

const HeadingService = styled.h1`
    font-family: Poppins;
    font-size: 48px;
    font-weight: 700;
    line-height: 54px;
    letter-spacing: 0em;
    text-align: left ;
    margin-bottom: 20px;
`;

const ServiceImageContainer = styled.div`
  position: relative;
  overflow: hidden;
`;

const ServiceContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
`;

const ServiceCard = styled.div`
  position: relative;
  overflow: hidden;
`;

const ServiceCardContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #fff;
  z-index: 1;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.7s ease, visibility 0.7s ease;
  border-radius: 30px;

  ${ServiceCard}:hover & {
    opacity: 1;
    visibility: visible;
  }
`;

const ServiceImage = styled.img`
width: 100%;
height: 282px;
border-radius: 30px;

  ${ServiceCard}:hover ~ ${ServiceCardContent} {
    opacity: 1;
    visibility: visible;
  }
`;

const ServiceHeading = styled.h2`
  font-family: Poppins;
  font-size: 24px;
  font-weight: 500;
  line-height: 27px;
  letter-spacing: 0em;
  text-align: center;
  color: #fff;
  margin-top: 10px;
`;
const ServiceOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 30px;
  width: 100%;
  height: 0;
  background: linear-gradient(to bottom, #0F97B5, #00c8ff);
  opacity: 0.7;
  visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: height 0.3s ease, opacity 0.2s ease, visibility 0.3s ease;

  ${ServiceImageContainer}:hover & {
    height: 100%;
    opacity: 0.7;
    visibility: visible;
  }
`;